import "./WidgetLeft.css"
import Charts from "../charts/Charts"
import { userData } from "../../dummyData"

const WidgetLeft = () => {
    return (
        <div className="charts_left">
            <div className="charts_left_title">
                <div>
                    <h1>Daily Reports</h1>
                    <p>Cupertino, California, USA</p>
                </div>
                <i className="fa fa-usd"></i>
            </div>
            <Charts className="chartt" data={userData} grid dataKey="Active User" />
        </div>
    )
}

export default WidgetLeft;